const footer = (): void => {
  const subscribeToggle = document.querySelectorAll<HTMLElement>(
    '.subscribe-modal__toggle'
  );
  subscribeToggle.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      document.body.classList.toggle('subscribe-modal--open');
    });
  });
};

export default footer;
